import { useState } from "react";
import axiosClient from "../api/axiosClient";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function VerifyOtp() {
  const [identifier, setIdentifier] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (newPassword !== confirmPassword) {
      setMessage("⚠️ Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await axiosClient.post("/auth/api/verify-otp", {
        email: identifier,
        username: identifier,
        mobile: identifier,
        otp,
        new_password: newPassword,
      });

      if (res.data.success) {
        setMessage("✅ Password reset successfully! Redirecting to login...");
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } else {
        setMessage("⚠️ " + res.data.message);
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      setMessage("❌ Failed to verify OTP. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        className="card shadow-lg border-0"
        style={{
          width: "100%",
          maxWidth: "420px",
          borderRadius: "15px",
          background: "rgba(255, 255, 255, 0.98)",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
          padding: "25px",
        }}
      >
        <div className="text-center mb-3">
          <img
            src="/dizypro-logo.png"
            alt="Dizypro Logo"
            style={{ height: "50px", marginBottom: "10px" }}
          />
          <h4 className="fw-bold text-primary">
            <i className="fas fa-key me-2"></i>
            Verify OTP & Reset Password
          </h4>
        </div>

        {message && (
          <div
            className={`alert ${
              message.startsWith("✅")
                ? "alert-success"
                : message.startsWith("⚠️")
                ? "alert-warning"
                : "alert-danger"
            }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">
              Registered Email / User ID / Mobile
            </label>
            <input
              type="text"
              className="form-control"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Enter your registered email, user ID, or mobile"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">OTP</label>
            <input
              type="text"
              className="form-control"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP received on email"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label fw-semibold">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              required
            />
          </div>

          <button
            className="btn btn-primary w-100 py-2"
            type="submit"
            disabled={loading}
            style={{
              background: "linear-gradient(45deg, #007bff, #0056b3)",
              border: "none",
              boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
            }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Verifying...
              </>
            ) : (
              <>
                <i className="fas fa-check-circle me-2"></i> Verify & Reset
              </>
            )}
          </button>

          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-link text-primary p-0"
              onClick={() => (window.location.href = "/")}
            >
              ← Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VerifyOtp;
